export function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}